import { RESOURCE_GROUPS_R, RESOURCE_TREE_R } from 'constants/actionTypes';

export const getResourceGroups = () => ({
  type: RESOURCE_GROUPS_R
});

export const getResourceTree = () => ({
  type: RESOURCE_TREE_R
});
